<template>
<div class="species">
    <el-container>
    <el-aside width="180px"></el-aside>
    <el-main>
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane name="1">
            <template v-slot:label>
            <span style="font-weight: bold; font-size: 15px;">Overview</span>
            </template>
            <Speciesfig />
        </el-tab-pane>
        <el-tab-pane name="2">
            <template v-slot:label>
            <span style="font-weight: bold; font-size: 15px;">Species Core Enhancer List</span>
            </template>
            <Specieslist />
        </el-tab-pane>
        </el-tabs>
    </el-main>
    <el-aside width="180px"></el-aside>
    </el-container>
</div>
</template>

<script>
import Speciesfig from "./Speciesfig.vue";
import Specieslist from "./Specieslist.vue";

export default {
    components: {
        Speciesfig,
        Specieslist,
    },
    data() {
        return {
        activeName: "1",
        };
    },
    methods: {
        handleClick(tab, event) {
        this.activeName = tab.name;
        },
    },
};
</script>

<style>
.species {
    margin-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Species.vue